/**
 * TODO comment what each one does
 */

export enum SearchMode {
  None = 'None', // Active and in internal supplier id (basically give you your own active products)
  AllAvailableForSaleByEntity = 'AllAvailableForSaleByEntity', // (active & global)
  AllEntityCatalogueProducts = 'AllEntityCatalogueProducts', // products in the entities catalogue
  ProductsOnInformalCatalogue = 'ProductsOnInformalCatalogue', // Supplier listed to buy
}
